import { VoiceConnectionType, VoicePreference } from '../../services/cxone-sdk.service';
import { logger } from '../../utils/logger';

const STORAGE_KEY = 'cxone_voice_preference';

export function loadSavedVoicePreference(): VoicePreference | null {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      return JSON.parse(saved);
    }
  } catch (e) {
    logger.warn('Failed to load voice preference:', e);
  }
  return null;
}

export function saveVoicePreference(preference: VoicePreference): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(preference));
  } catch (e) {
    logger.warn('Failed to save voice preference:', e);
  }
}

export function clearSavedVoicePreference(): void {
  localStorage.removeItem(STORAGE_KEY);
}

export function buildVoicePreference(
  selectedType: VoiceConnectionType,
  phoneNumber: string,
  stationId: string
): VoicePreference {
  return {
    type: selectedType,
    phoneNumber: selectedType === 'phone' ? phoneNumber : undefined,
    stationId: selectedType === 'station' ? stationId : undefined,
  };
}

export function isVoicePreferenceValid(
  selectedType: VoiceConnectionType,
  phoneNumber: string,
  stationId: string
): boolean {
  if (selectedType === 'phone') {
    return phoneNumber.trim().length > 0;
  }
  if (selectedType === 'station') {
    return stationId.trim().length > 0;
  }
  return true;
}
